// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RemovePaymentCard_wrapper_3xAAX","caption":"RemovePaymentCard_caption_3zsOB","info":"RemovePaymentCard_info_HMOOf"};